import { ApiResourceBaseClass as r } from "./baseApiCalls.js";
const t = "feedback/feedback_form";
class d extends r {
  /**
   * Searches for feedback forms.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/feedback/feedback_form`
   *
   * @param {number} orgId
   */
  async getFeedbackForms(a) {
    const { data: e } = await this.get(t, {
      org_id: a
    });
    return e;
  }
  /**
   * Updates a feedback form
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/feedback/feedback_form/:id`
   *
   * @param {string} formId ID of the feedback form
   * @param {UpdateFeedbackFormPayload} payload Feedback form data
   */
  async updateFeedbackForm(a, e) {
    const { data: s } = await this.put(`${t}/${a}`, e);
    return s;
  }
  /**
   * Creates a feedback form
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/feedback/feedback_form`
   *
   * @param {CreateFeedbackFormPayload} payload Feedback form data
   */
  async createFeedbackForm(a) {
    const { data: e } = await this.post(t, a);
    return e;
  }
}
export {
  d as FeedbackForm
};
